// extracted by mini-css-extract-plugin
export default {"container":"banner_container__854pn"};